import { useState, useRef } from "react";
import { Input, Button } from "@imedcl/design-system";
import { validateRUT, onlyDashRut } from "@imedcl/valida-rut";
import { format } from "rut.js";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import { encode } from "string-encode-decode";
import * as Loader from "react-loader-spinner";

export default function FormContent() {
  const [loading, setLoading] = useState(false);
  const [rut, setFormatRut] = useState("");
  const captchaRef = useRef(null);
  const URL_PFP_BACKEND =
    process.env.REACT_APP_PFP_BACKEND || window._env_.REACT_APP_PFP_BACKEND;
  const ReCaptchaKey =
    process.env.REACT_APP_RECAPCHA_KEY || window._env_.REACT_APP_RECAPCHA_KEY;
  const APIKEY_PRE =
    process.env.REACT_APP_APIKEY_PRE || window._env_.REACT_APP_APIKEY_PRE;
  const [buttonDisable, setButtonDisable] = useState(false);
  const navigate = useNavigate();
  const [textoValidacion, setValidation] = useState("");
  axios.defaults.headers.common["apikey"] = `${APIKEY_PRE}`;

  //Funcion recapchat.
  function onChange(value) {
    if (value) {
      checkRut();
    } else {
      setButtonDisable(false);
      if (value) {
        checkRut();
      }
    }
  }

  const formatRut = (element) => {
    setFormatRut(format(element.target.value));
    //valida rut y le da estilo con stateType del input.
    const result = validateRUT(onlyDashRut(element.target.value));
    if (result === true) {
      setValidation("");
    } else {
      setValidation("error");
    }
  };

  //Funcion que ira a buscar las deudas del rut consultado.
  const getDebts = async () => {
    try {
      setLoading(true);
      await axios.get(`${URL_PFP_BACKEND}/v1/consultaDeuda?rut=${onlyDashRut(rut)}`).then(function (response) {
        console.log(response.data);
        let json = {
          status: 200,
          cantidad: response.data.cantidad,
          documentos: response.data.documentos,
          selectedRows: {},
        };
        if (response.data.status === 200) {
          if (response.data.cantidad === 1) {
            if (response.data.documentos["0"]["xError"] === "No existen documentos para el rut consultado") {
              //enviamos a modal de usuario que no tiene deuda.
              setLoading(false);
              navigate("noDebt");
            }
            if (response.data.documentos["0"]["xError"] === "Rut de cliente no existe o Rut no es válido") {
              //modal que controla si el usuario es cliente o si no esta habilitado para pagar.
              setLoading(false);
              navigate("errorClient", { state: response.data.documentos["0"] });
            }
            setLoading(false);
            let token = encode("Session1");
            localStorage.setItem("session", token);
            localStorage.setItem("rt", encode(rut));
            navigate("listDebts", { state: json });
          } else {
            //Generamos token
            setLoading(false);
            let token = encode("Session1");
            localStorage.setItem("session", token);
            localStorage.setItem("rt", encode(rut));
            navigate("listDebts", { state: json });
          }
        } else {
          setLoading(false);
          navigate("disconnect");
        }
      }).catch(function (error) {
        setLoading(false);
        navigate("disconnect");
      });
    } catch (error) {
      setLoading(false);
      navigate("disconnect");
    }
  };

  //Funcion que validara el rut del usuario.
  const checkRut = () => {
    const value = rut;
    try {
      //le da formato al rut en el input
      setFormatRut(format(value));
      //variable que guarda el resultado si el rut es true (valido) o invalido (false).
      if (value === "") {
        setButtonDisable(false);
      } else {
        const rutValid = validateRUT(onlyDashRut(value));
        if (rutValid) {
          if (value !== "0" && captchaRef.current.getValue()) {
            setButtonDisable(true);
            return true;
          } else {
            setButtonDisable(false);
            captchaRef.current.reset();
            return false;
          }
        } else {
          setButtonDisable(false);
          captchaRef.current.reset();
          return false;
        }
      }
    } catch (error) {
      setButtonDisable(false);
      captchaRef.current.reset();
      return false;
    }
  };

  return (
    <div className="flex items-center justify-center">
      <div className="shadow-lg bg-white w-96 border-t-8 rounded border-info-dark h-[24rem]">
        <div className="mt-4 mx-8">
          <h2 className="text-center text-2xl font-bold tracking-normal text-info-dark">
            Pago de cuenta
          </h2>
          <p className="text-center text-sm text-neutral-60 font-medium leading-4 tracking-tight m-1">
            Sólo debes ingresar el rut persona{" "}
          </p>
          <p className="text-center text-sm text-neutral-60 font-medium leading-4 tracking-tight m-0">
            natural o empresa
          </p>
          <div className="mt-7 justify-center ">
            <Input
              name="rut"
              onChange={formatRut}
              placeholder="Formato 12345678-9"
              stateMessage="RUT ingresado inválido"
              stateType={textoValidacion}
              title="RUT"
              type="text"
              value={rut}
              customSize="l"
            />
            <div className="mt-5 justify-center text-center">
              <ReCAPTCHA
                sitekey={ReCaptchaKey}
                onChange={onChange}
                size="normal"
                ref={captchaRef}
              />
            </div>
            <div className="justify-center text-center">
              <Button
                className="m-0 mx-auto mt-4 text-center"
                size="m"
                type="secondary"
                disabled={!buttonDisable}
                onMouseOver={checkRut}
                onClick={getDebts}
              >
                {!loading ? (
                  <span>Consulta deuda</span>
                ) : (
                  <Loader.ThreeDots
                    height="17"
                    width="80"
                    radius="9"
                    color="#fff"
                    ariaLabel="three-dots-loading"
                    visible={true}
                  />
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
